const FIRST_PAGE = 1;
const FETCH_LIMIT_LOW = 10;
const FETCH_LIMIT_MIDDLE = 20;
const FETCH_LIMIT_HIGH = 100;
export { FIRST_PAGE, FETCH_LIMIT_LOW, FETCH_LIMIT_MIDDLE, FETCH_LIMIT_HIGH };
